(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    
    // Constants for configuration
    this.SCROLL_DEBOUNCE_MS = 66;
    this.MEDIA_QUERY = '(max-width: 990px)';
    this.STICKY_TYPES = {
      ALWAYS: 'always',
      REDUCE_LOGO: 'reduce-logo-size'
    };
    
    // Bound methods to maintain correct 'this' context
    this.handleScroll = this.debounce(this.onScroll.bind(this), 10);
    this.handleResize = this.setHeaderHeight.bind(this);
    this.handlePreventReveal = () => this.preventReveal = true;
    
    // Initialize state
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.isScrolling = null;
    this.headerBounds = {};
  }

  // Lifecycle methods
  connectedCallback() {
    try {
      this.initializeHeader();
      this.setupEventListeners();
      this.createIntersectionObserver();
    } catch (error) {
      console.error('Error initializing sticky header:', error);
    }
  }

  disconnectedCallback() {
    try {
      this.cleanupEventListeners();
    } catch (error) {
      console.error('Error cleaning up sticky header:', error);
    }
  }

  // Initialization
  initializeHeader() {
    this.header = this.querySelector('.section-header') || document.querySelector('.section-header');
    if (!this.header) {
      throw new Error('Header element not found');
    }

    this.headerIsAlwaysSticky = this.isAlwaysSticky();
    this.predictiveSearch = this.querySelector('predictive-search');
    
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.setHeaderHeight();
  }

  isAlwaysSticky() {
    const stickyType = this.getAttribute('data-sticky-type');
    return stickyType === this.STICKY_TYPES.ALWAYS || 
           stickyType === this.STICKY_TYPES.REDUCE_LOGO;
  }

  // Event Listeners
  setupEventListeners() {
    const mediaQuery = window.matchMedia(this.MEDIA_QUERY);
    mediaQuery.addListener(this.handleResize);

    this.addEventListener('preventHeaderReveal', this.handlePreventReveal);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  cleanupEventListeners() {
    const mediaQuery = window.matchMedia(this.MEDIA_QUERY);
    mediaQuery.removeListener(this.handleResize);

    this.removeEventListener('preventHeaderReveal', this.handlePreventReveal);
    window.removeEventListener('scroll', this.handleScroll);
  }

  // Intersection Observer
  createIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      },
      { threshold: [0, 1] }
    );

    observer.observe(this.header);
  }

  // Header Height Management
  setHeaderHeight() {
    if (!this.header) return;
    
    requestAnimationFrame(() => {
      const height = `${this.header.offsetHeight}px`;
      document.documentElement.style.setProperty('--header-height', height);
    });
  }

  // Scroll Handling
  onScroll() {
    if (!this.header || (this.predictiveSearch?.isOpen)) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (this.shouldHideHeader(scrollTop)) {
      this.handleHeaderHide();
    } else if (this.shouldRevealHeader(scrollTop)) {
      this.handleHeaderReveal();
    } else if (this.shouldResetHeader(scrollTop)) {
      this.handleHeaderReset();
    }

    this.currentScrollTop = scrollTop;
  }

  shouldHideHeader(scrollTop) {
    return scrollTop > this.currentScrollTop && 
           scrollTop > this.headerBounds.bottom;
  }

  shouldRevealHeader(scrollTop) {
    return scrollTop < this.currentScrollTop && 
           scrollTop > this.headerBounds.bottom;
  }

  shouldResetHeader(scrollTop) {
    return scrollTop <= this.headerBounds.top;
  }

  // Header State Management
  handleHeaderHide() {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventHide) {
      requestAnimationFrame(() => this.hide());
    }
  }

  handleHeaderReveal() {
    this.header.classList.add('scrolled-past-header');
    
    if (!this.preventReveal) {
      requestAnimationFrame(() => this.reveal());
    } else {
      this.handlePreventReveal();
      clearTimeout(this.isScrolling);
      
      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, this.SCROLL_DEBOUNCE_MS);
      
      requestAnimationFrame(() => this.hide());
    }
  }

  handleHeaderReset() {
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(() => this.reset());
  }

  // Header UI States
  hide() {
    if (this.headerIsAlwaysSticky) return;
    
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  // Utility Methods
  closeMenuDisclosure() {
    if (!this.disclosures) {
      this.disclosures = this.header.querySelectorAll('header-menu');
    }
    this.disclosures.forEach(disclosure => disclosure.close?.());
  }

  closeSearchModal() {
    if (!this.searchModal) {
      this.searchModal = this.header.querySelector('details-modal');
    }
    this.searchModal?.close?.(false);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
